import React, { Component } from 'react';
import PropTypes from 'prop-types';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M225.923 354.706c-8.098 0-16.195-3.092-22.369-9.263L9.27 151.157c-12.359-12.359-12.359-32.397 0-44.751 12.354-12.354 32.388-12.354 44.748 0l171.905 171.915 171.906-171.909c12.359-12.354 32.391-12.354 44.744 0 12.365 12.354 12.365 32.392 0 44.751L248.292 345.449c-6.177 6.172-14.274 9.257-22.369 9.257z"
});

var ArrowDown = 'data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22iso-8859-1%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Capa_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%22451.847px%22%20height%3D%22451.847px%22%20viewBox%3D%220%200%20451.847%20451.847%22%20style%3D%22enable-background%3Anew%200%200%20451.847%20451.847%3B%22%20%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Cpath%20d%3D%22M225.923%2C354.706c-8.098%2C0-16.195-3.092-22.369-9.263L9.27%2C151.157c-12.359-12.359-12.359-32.397%2C0-44.751%20%20c12.354-12.354%2C32.388-12.354%2C44.748%2C0l171.905%2C171.915l171.906-171.909c12.359-12.354%2C32.391-12.354%2C44.744%2C0%20%20c12.365%2C12.354%2C12.365%2C32.392%2C0%2C44.751L248.292%2C345.449C242.115%2C351.621%2C234.018%2C354.706%2C225.923%2C354.706z%22%2F%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3C%2Fsvg%3E';

var _ref$1 =
/*#__PURE__*/
React.createElement("path", {
  d: "M345.441 248.292L151.154 442.573c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744L278.318 225.92 106.409 54.017c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.287 194.284c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373z"
});

var ArrowRight = 'data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22iso-8859-1%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Capa_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%22451.846px%22%20height%3D%22451.847px%22%20viewBox%3D%220%200%20451.846%20451.847%22%20style%3D%22enable-background%3Anew%200%200%20451.846%20451.847%3B%22%20%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Cpath%20d%3D%22M345.441%2C248.292L151.154%2C442.573c-12.359%2C12.365-32.397%2C12.365-44.75%2C0c-12.354-12.354-12.354-32.391%2C0-44.744%20%20L278.318%2C225.92L106.409%2C54.017c-12.354-12.359-12.354-32.394%2C0-44.748c12.354-12.359%2C32.391-12.359%2C44.75%2C0l194.287%2C194.284%20%20c6.177%2C6.18%2C9.262%2C14.271%2C9.262%2C22.366C354.708%2C234.018%2C351.617%2C242.115%2C345.441%2C248.292z%22%2F%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3Cg%3E%3C%2Fg%3E%3C%2Fsvg%3E';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".TreeNode_short-text__1JGyG {\r\n  display: inline-block;\r\n  white-space: nowrap;\r\n  overflow: hidden !important;\r\n  text-overflow: ellipsis;\r\n  width: 80%;\r\n}\r\n.TreeNode_none-selectable-text__2_J9x {\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n}\r\n.TreeNode_treenode__3jxSR:hover {\r\n  outline: 1px solid #257AFD;\r\n}";
var css$1 = { "short-text": "TreeNode_short-text__1JGyG", "none-selectable-text": "TreeNode_none-selectable-text__2_J9x", "treenode": "TreeNode_treenode__3jxSR" };
styleInject(css);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function ExpandIcon() {
  return React.createElement('img', { src: ArrowDown, width: 15, height: 15 });
}
function CollapseIcon() {
  return React.createElement('img', { src: ArrowRight, width: 15, height: 15 });
}

var TreeNode = function TreeNode(props) {
  var data = props.data,
      onCollapse = props.onCollapse,
      onExpand = props.onExpand,
      onToggleSelect = props.onToggleSelect,
      path = props.path,
      indentChild = props.indentChild,
      selectionBackColor = props.selectionBackColor;

  var renderRow = function renderRow(data, indentation, path) {
    var icon = data.icon,
        title = data.title,
        childrenNode = data.childrenNode,
        isExpanded = data.isExpanded,
        isSelected = data.isSelected;

    var hasChildren = childrenNode && childrenNode.length > 0;
    var styleOfSelected = isSelected ? { backgroundColor: selectionBackColor } : undefined;
    return React.createElement(
      'div',
      { className: css$1['treenode'], key: path, style: _extends$2({ width: '100%' }, styleOfSelected) },
      React.createElement(
        'div',
        { style: { marginLeft: indentation } },
        hasChildren && (isExpanded ? React.createElement(
          'span',
          {
            onClick: function onClick() {
              onCollapse && onCollapse(path, _extends$2({}, data, { isExpanded: false }));
            }
          },
          React.createElement(ExpandIcon, null)
        ) : React.createElement(
          'span',
          {
            onClick: function onClick() {
              onExpand && onExpand(path, _extends$2({}, data, { isExpanded: true }));
            }
          },
          React.createElement(CollapseIcon, null)
        )),
        icon,
        React.createElement(
          'span',
          {
            className: css$1['short-text'] + ' ' + css$1['none-selectable-text'],
            onClick: function onClick(e) {
              onToggleSelect && onToggleSelect(e, path, _extends$2({}, data, { isSelected: !isSelected }));
            }
          },
          title
        )
      )
    );
  };

  var rows = [];
  var queue = [{ data: data, indentation: 0, path: path }];
  while (queue.length > 0) {
    var _queue$shift = queue.shift(),
        _data = _queue$shift.data,
        indentation = _queue$shift.indentation,
        _path = _queue$shift.path;

    rows.push(renderRow(_data, indentation, _path));
    var childrenNode = _data.childrenNode,
        isExpanded = _data.isExpanded;

    var hasChildren = childrenNode && childrenNode.length > 0;
    // render children node only when parent node had been expanded
    if (hasChildren && isExpanded) {
      for (var i = 0, numIter = childrenNode.length; i < numIter; i++) {
        queue.push({
          data: childrenNode[i],
          indentation: indentation + indentChild,
          path: _path.concat(i)
        });
      }
    }
  }
  return rows;
};

TreeNode.propTypes = {
  data: PropTypes.shape({
    icon: PropTypes.node,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    childrenNode: PropTypes.array,
    isExpanded: PropTypes.bool,
    isSelected: PropTypes.bool
  }),
  /**
   * Callback when expand a parent node by clicking expand indicator
   * @param {Array} path - Path to this node
   * @param {Object} node - Data of this node
   */
  onExpand: PropTypes.func,
  /**
   * Callback when collapse a parent node by clicking collapse indicator
   * @param {Array} path - Path to this node
   * @param {Object} node - Data of this node
   */
  onCollapse: PropTypes.func,
  /**
   * Callback when select a node by clicking on its title
   * @param {Object} event - Click event
   * @param {Array} path - Path to this node
   * @param {Object} node - Data of this node
   */
  onToggleSelect: PropTypes.func
};

var css$2 = ".TreeView_treeview__H_6Ka {\r\n  padding: 1px;\r\n}";
var css$3 = { "treeview": "TreeView_treeview__H_6Ka" };
styleInject(css$2);

var ERROR_UNDEFINED_VALUE = 1;
var ERROR_NULL_VALUE = 2;
var ERROR_TYPE_MISMATCH = 3;

var TreeView = function (_Component) {
  inherits(TreeView, _Component);

  function TreeView(props) {
    classCallCheck(this, TreeView);

    var _this = possibleConstructorReturn(this, (TreeView.__proto__ || Object.getPrototypeOf(TreeView)).call(this, props));

    _initialiseProps.call(_this);

    var internalTree = _this._parseToInternalTree(props.initialData);
    _this.state = {
      internalTree: internalTree
    };
    return _this;
  }

  /**
   * Get a node
   * @param {Object} tree Tree data
   * @param {Array} path Path to node
   * @returns {Object} Node data
   */


  /**
   * Update a node
   * @param {Object} tree Tree data
   * @param {Array} path Path to node
   * @param {Object} nodeData New data of node
   * @returns {Object} Updated tree
   */


  /**
   * Check if 2 path are identical
   * @param {Array} path1
   * @param {Array} path2
   */


  /**
   * Traverse tree and invoke callback on each node
   * @param {Array} tree Tree data
   * @param {Function} callback function invoked on each node: `(current, path, parent) => any`
   */


  createClass(TreeView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          indentChild = _props.indentChild,
          selectionBackColor = _props.selectionBackColor;

      var data = this.state.internalTree.childrenNode;
      return React.createElement(
        'div',
        { style: this.props.style },
        React.createElement(
          'div',
          { className: css$3['treeview'] },
          data.map(function (node, index) {
            var path = [index];
            return React.createElement(TreeNode, {
              key: index,
              path: path,
              data: node,
              onExpand: _this2._onExpandNode,
              onCollapse: _this2._onCollapseNode,
              onToggleSelect: _this2._onToggleSelectNode,
              indentChild: indentChild,
              selectionBackColor: selectionBackColor
            });
          })
        )
      );
    }
  }]);
  return TreeView;
}(Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this._validateInitialData = function (initialData) {
    var type = typeof initialData === 'undefined' ? 'undefined' : _typeof(initialData);
    if (type == 'undefined') {
      throw {
        code: ERROR_UNDEFINED_VALUE
      };
    }
    if (type == null) {
      throw {
        code: ERROR_NULL_VALUE,
        message: 'initial data can not be null'
      };
    }
    if (type == 'number' || type == 'string' || type == 'symbol') {
      throw {
        code: ERROR_TYPE_MISMATCH,
        message: 'initial data can not be value of type ' + type
      };
    }
  };

  this._parseToInternalTree = function (initialData) {
    var internalTree = {
      childrenNode: []
    };
    // validate
    try {
      _this3._validateInitialData(initialData);
    } catch (_ref) {
      var code = _ref.code;
      var message = _ref.message;

      switch (code) {
        case ERROR_UNDEFINED_VALUE:
          {
            initialData = [];
            break;
          }
        case ERROR_NULL_VALUE:
        case ERROR_TYPE_MISMATCH:
          {
            console.error(message);
            return internalTree;
          }
      }
    }
    // build queue
    var queue = [];
    for (var i = 0; i < initialData.length; i++) {
      queue.push({
        parent: internalTree,
        current: initialData[i],
        path: [i]
      });
    }
    // traverse
    while (queue.length > 0) {
      var _queue$shift = queue.shift(),
          current = _queue$shift.current,
          parent = _queue$shift.parent,
          path = _queue$shift.path;

      var clonedCurrent = _extends$2({}, current, { parent: parent });

      if (clonedCurrent.childrenNode) {
        // queue children
        for (var _i = 0; _i < clonedCurrent.childrenNode.length; _i++) {
          queue.push({
            parent: clonedCurrent,
            current: clonedCurrent.childrenNode[_i],
            path: path.concat([_i])
          });
        }
        // reset children to empty array so that new children will be appended later
        clonedCurrent.childrenNode = [];
      }
      // add cloned node
      parent.childrenNode.push(clonedCurrent);
    }

    return internalTree;
  };

  this._getNode = function (tree, path) {
    var runner = tree; // runner

    // traverse
    for (var i = 0; i < path.length; i++) {
      var index = path[i];
      runner = runner.childrenNode[index];
    }

    return runner;
  };

  this._setNode = function (tree, path, nodeData) {
    var updatedTree = _extends$2({}, tree);
    var tempNode = updatedTree; // runner

    // traverse to get parent of node that need updated
    for (var i = 0, numIter = path.length - 1, index; i < numIter; i++) {
      index = path[i];
      tempNode = tempNode.childrenNode[index];
    }

    var nodeIndex = path[path.length - 1]; // index of node that need to be updated
    tempNode.childrenNode = tempNode.childrenNode.map(function (childNode, idx) {
      return nodeIndex === idx ? _extends$2({}, childNode, nodeData) : childNode;
    });

    return updatedTree;
  };

  this._isSamePath = function (path1, path2) {
    if (path1.length == path2.length) {
      for (var i = 0; i < path1.length; i++) {
        if (path1[i] !== path2[i]) {
          return false;
        }
      }
      return true;
    }
    return false;
  };

  this._traverse = function (tree, callback) {
    var queue = [];
    var invokeCallbackQueue = [];
    // build queue
    var tempRoot = _extends$2({}, tree);
    queue.push({
      parent: null,
      current: tempRoot,
      path: []
    });
    // traverse
    while (queue.length > 0) {
      var _queue$shift2 = queue.shift(),
          current = _queue$shift2.current,
          parent = _queue$shift2.parent,
          path = _queue$shift2.path;

      invokeCallbackQueue.push({
        parent: parent,
        current: current,
        path: path
      });
      if (current.childrenNode) {
        // queue children
        for (var i = 0; i < current.childrenNode.length; i++) {
          queue.push({
            parent: current,
            current: current.childrenNode[i],
            path: path.concat([i])
          });
        }
      }
    }

    // invoke callback on each node
    // we do not invoke when traverse with $queue to prevent accidentally changing value of reference
    // the complexity will be 2n but it's worthy
    for (var _i2 = 0, numIter = invokeCallbackQueue.length; _i2 < numIter; _i2++) {
      callback(invokeCallbackQueue[_i2].current, invokeCallbackQueue[_i2].path, invokeCallbackQueue[_i2].parent);
    }
  };

  this._onCollapseNode = function (path, node) {
    var onCollapseNode = _this3.props.onCollapseNode;


    _this3.setState(function (state) {
      var internalTree = state.internalTree;

      var updatedTree = _this3._setNode(internalTree, path, node);
      if (onCollapseNode) {
        onCollapseNode({ path: path, node: node }, updatedTree.childrenNode);
      }
      return {
        internalTree: updatedTree
      };
    });
  };

  this._onExpandNode = function (path, node) {
    var onExpandNode = _this3.props.onExpandNode;


    _this3.setState(function (state) {
      var internalTree = state.internalTree;

      var updatedTree = _this3._setNode(internalTree, path, node);
      if (onExpandNode) {
        onExpandNode({ path: path, node: node }, updatedTree.childrenNode);
      }
      return {
        internalTree: updatedTree
      };
    });
  };

  this._onToggleSelectNode = function (e, path, node) {
    var onClickNode = _this3.props.onClickNode;

    var isPressingCtrlKey = e.ctrlKey;

    _this3.setState(function (state) {
      var updatedTree = void 0;
      if (isPressingCtrlKey) {
        // user is pressing CTRL, this means multi-select
        updatedTree = _this3._setNode(state.internalTree, path, node);
      } else {
        // single select: select a node will deselect others
        updatedTree = _extends$2({}, state.internalTree);
        _this3._traverse(updatedTree, function (nodeData, nodePath) {
          if (_this3._isSamePath(path, nodePath)) {
            nodeData.isSelected = true;
          } else {
            nodeData.isSelected = false;
          }
        });
      }
      if (onClickNode) {
        onClickNode(e, { path: path, node: node }, updatedTree.childrenNode);
      }
      return {
        internalTree: updatedTree
      };
    });
  };
};

TreeView.propTypes = {
  initialData: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.node,
    title: PropTypes.string.isRequired,
    childrenNode: PropTypes.array,
    isExpanded: PropTypes.bool,
    isSelected: PropTypes.bool
  })),

  /**
   * Indentation of children compares to its parent
   * Default is 30
   */
  indentChild: PropTypes.number,

  /**
   * Background color of selected node
   */
  selectionBackColor: PropTypes.string,

  /**
   * Callback when click a tree node
   * `(e, fromNode, newTree) => any`
   * @param {Object} e Event data
   * @param {Object} fromNode Data of node that trigger this callback
   * - path: Array - Path to selected node
   * - node: Object - Data of selected node
   * @param {Object} newTree - Updated tree
   */
  onClickNode: PropTypes.func,

  /**
   * Callback when expand a parent node by clicking expand indicator
   * `(fromNode, newTree) => any`
   * @param {Object} fromNode Data of node that trigger this callback
   * - path: Array - Path to expanded node
   * - node: Object - Data of expanded node
   * @param {Object} newTree - Updated tree
   */
  onExpandNode: PropTypes.func,

  /**
   * Callback when collapse a parent node by clicking collapse indicator
   * `(fromNode, newTree) => any`
   * @param {Object} fromNode Data of node that trigger this callback
   * - path: Array - Path to collapsed node
   * - node: Object - Data of collapsed node
   * @param {Object} newTree - Updated tree
   */
  onCollapseNode: PropTypes.func
};

TreeView.defaultProps = {
  initialData: [],
  selectionBackColor: '#257AFD',
  indentChild: 30
};

export default TreeView;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 18
// module chunks = 0